"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getElementkitConfig = exports.setElementkitConfig = void 0;
const master_1 = require("../constants/master");
let config;
const setElementkitConfig = (newConfig) => {
    config = newConfig;
    if (!newConfig.isWhitelabel) {
        (0, master_1.setPrimaryColor)(newConfig.primaryColor, newConfig.isWhitelabel);
        (0, master_1.setSubDomain)(newConfig.subDomain);
        (0, master_1.setLogoLink)(newConfig.logoLink);
    }
};
exports.setElementkitConfig = setElementkitConfig;
const getElementkitConfig = () => {
    if (!config) {
        throw new Error("Configuration has not been set");
    }
    return config;
};
exports.getElementkitConfig = getElementkitConfig;
